if (!customElements.get('cart-pairs')) {
  customElements.define('cart-pairs', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.load(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async load(signal) {
      const ids = this.dataset.productIds.split(',').filter(Boolean);
      const seen = new Set(ids);
      const list = this.querySelector('ul');
      // Keep request count bounded for unusually large carts.
      const results = await Promise.allSettled(ids.slice(0, 8).map(async (id) => {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('section_id', 'cart-pairs-products');
        url.searchParams.set('product_id', id);
        url.searchParams.set('intent', 'complementary');
        url.searchParams.set('limit', '10');
        const response = await fetch(url, { signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }));
      if (signal.aborted || !this.isConnected) return;
      for (const result of results) {
        if (result.status !== 'fulfilled') continue;
        for (const card of result.value.querySelectorAll('.cart-pairs__item')) {
          if (seen.has(card.dataset.productId) || list.children.length >= 4) continue;
          seen.add(card.dataset.productId);
          list.append(card);
        }
      }
      this.hidden = list.children.length === 0;
    }
  });
}
